import {useEffect, useMemo, useState} from "react";
import {AmiRepository} from "../../../../repositories/AmiRepository";

// The flow's AMI extensions, plus a lookup by id for showing a campaign's extensionId
export const useAmiExtensions = (flowUid) => {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!flowUid) return;
    setLoading(true);
    setError(false);
    AmiRepository.listExtensions(flowUid)
      .then(res => setExtensions(res?.data?.extensions || []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [flowUid]);

  const byId = useMemo(() => {
    const map = new Map();
    extensions.forEach(ext => ext.id && map.set(String(ext.id), ext));
    return map;
  }, [extensions]);

  const getExtension = (id) => (id ? byId.get(String(id)) || null : null);

  return {extensions, loading, error, getExtension};
};

// AMI extensions of several flows (e.g. every language of a project), looked up by id
export const useAmiExtensionsOfFlows = (flowUids) => {
  const key = (flowUids || []).filter(Boolean).join(",");
  const [extensions, setExtensions] = useState([]);

  useEffect(() => {
    if (!key) return;
    let cancelled = false;
    Promise.all(key.split(",").map(flowUid => AmiRepository.listExtensions(flowUid)
      .then(res => res?.data?.extensions || [])
      .catch(() => [])))
      .then(lists => !cancelled && setExtensions(lists.flat()));
    return () => {
      cancelled = true;
    };
  }, [key]);

  const byId = useMemo(() => {
    const map = new Map();
    extensions.forEach(ext => ext.id && map.set(String(ext.id), ext));
    return map;
  }, [extensions]);

  return {getExtension: (id) => (id ? byId.get(String(id)) || null : null)};
};

// "950001 · Support bot"
export const extensionLabel = (ext) => ext ? [ext.extension, ext.name].filter(Boolean).join(" · ") : "";
